import { useState, useEffect, useCallback } from "react";
import { LayoutDashboard, Mail, Users, Disc3, ClipboardList, DollarSign, LifeBuoy } from "lucide-react";
import DashboardShell from "@/components/dashboard/DashboardShell";
import { api } from "@/lib/api";
import AdminOverview from "./AdminOverview";
import AdminInvitations from "./AdminInvitations";
import AdminArtists from "./AdminArtists";
import AdminReleases from "./AdminReleases";
import AdminWaitlist from "./AdminWaitlist";
import AdminRoyalties from "./AdminRoyalties";
import AdminTickets from "@/components/support/AdminTickets";

export default function AdminApp() {
  const [active, setActive] = useState("overview");
  const [stats, setStats] = useState(null);

  const loadStats = useCallback(async () => {
    try {
      const { data } = await api.get("/admin/stats");
      setStats(data);
    } catch (e) {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    loadStats();
  }, [loadStats]);

  const nav = [
    { key: "overview", label: "Overview", icon: LayoutDashboard },
    { key: "invitations", label: "Invitations", icon: Mail, badge: stats?.pending_invites },
    { key: "artists", label: "Members", icon: Users },
    { key: "releases", label: "Releases", icon: Disc3, badge: stats?.in_review },
    { key: "royalties", label: "Royalties", icon: DollarSign, badge: stats?.pending_withdrawals },
    { key: "support", label: "Support Tickets", icon: LifeBuoy, badge: stats?.open_tickets },
    { key: "waitlist", label: "Waitlist", icon: ClipboardList, badge: stats?.waitlist_count },
  ];

  const titles = {
    overview: "Overview",
    invitations: "Invitations",
    artists: "Members",
    releases: "Releases",
    royalties: "Royalties",
    support: "Support Tickets",
    waitlist: "Waitlist",
  };

  return (
    <DashboardShell title={titles[active]} badge="Super Admin" nav={nav} active={active} setActive={setActive}>
      {active === "overview" && <AdminOverview stats={stats} goto={setActive} />}
      {active === "invitations" && <AdminInvitations onChange={loadStats} />}
      {active === "artists" && <AdminArtists onChange={loadStats} />}
      {active === "releases" && <AdminReleases onChange={loadStats} />}
      {active === "royalties" && <AdminRoyalties onChange={loadStats} />}
      {active === "support" && <AdminTickets onChange={loadStats} />}
      {active === "waitlist" && <AdminWaitlist />}
    </DashboardShell>
  );
}
